import { AuthProtectedButton, Button, SvgIconUrl } from 'common/components';

import { useI18n } from 'common/hooks';
import svgIcons from 'common/svgIcons';

import { routes } from 'routes/routes.constants';

import './index.css';

const SessionExpirationPopupComponent = () => {
  const { translate } = useI18n();

  return (
    <div data-test='session-expiration-popup' className='session-expiration-popup'>
      <div className='session-expiration-popup__icon icon-shadow'>
        <SvgIconUrl symbol={svgIcons.NotFoundTrades()} />
      </div>
      <h3 className='session-expiration-popup__title'>{translate('mobile.session-exp-popup.title')}</h3>
      <p className='session-expiration-popup__descr'>{translate('mobile.session-exp-popup.descr')}</p>
      <AuthProtectedButton forceUnAuthorizedUser>
        <Button large stretch className='session-expiration-popup__btn'>
          {translate('mobile.session-exp-popup.btn')}
        </Button>
      </AuthProtectedButton>
    </div>
  );
};

export default () => ({
  component: <SessionExpirationPopupComponent />,
  wrapperClassName: 'session-expiration-popup-wrapper',
  hideCloseIcon: false,
  title: '',
  onCloseHandler: () =>
    window._authProtected ? window.location.assign(routes.getRoot()) : window.location.assign(window.location.href),
});
